import { __decorate, __metadata } from "tslib";
import { h, Host } from "@stencil/core";
import { Logger } from "../../../utils/log";
import { BEM } from "../../../utils/bem";
export class NavLinkGrid {
    createLogger(log) {
        this.log = log;
    }
    /**
     * RENDER
     * ------------------------------------------------------
     */
    render() {
        const block = BEM.block('nav-link-grid');
        return (h(Host, { key: '9aca76046a51bc001c233e0b8ee24fa863968d0d', class: Object.assign({}, block.class()) }, h("slot", { key: '3e2ceccc2ffe6f231c6900a869a863fec0c153ca' })));
    }
    static get is() { return "bal-nav-link-grid"; }
    static get originalStyleUrls() {
        return {
            "$": ["bal-nav-link-grid.sass"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["bal-nav-link-grid.css"]
        };
    }
}
__decorate([
    Logger('bal-nav-link-grid'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Function]),
    __metadata("design:returntype", void 0)
], NavLinkGrid.prototype, "createLogger", null);
